import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  extractions: [],
  currentPage: 1,
  totalPages: 1,
  totalDocuments: 0,
  loading: false,
  isDataExtractionReportDownloaded: false,
  error: null,
};

const pdfDataExtractionSlice = createSlice({
  name: 'extractions',
  initialState,
  reducers: {
    fetchPdfDataExtractionRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPdfDataExtractionSuccess(state, action) {
      state.loading = false;
      state.extractions = action.payload.extractions;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalDocuments = action.payload.totalDocuments;
    },
    fetchPdfDataExtractionFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    markPdfDataExtractionReportDownloaded(state, action) {
      state.isPdfDataExtractionReportDownloaded = action.payload;
    },
  },
});

export const {
  fetchPdfDataExtractionRequest,
  fetchPdfDataExtractionSuccess,
  fetchPdfDataExtractionFailure,
  markPdfDataExtractionReportDownloaded,
} = pdfDataExtractionSlice.actions;

export default pdfDataExtractionSlice.reducer;
